import React, { Component, Fragment } from 'react';
import ApiService from '../modules/ApiService'
import withAuth from '../components/withAuth'
import { withStyles } from '@material-ui/core/styles'
import TopBar from '../components/TopBar';
import { Grid, Container, Paper, Typography, List, ListItem, ListItemText, Card } from '@material-ui/core'

const styles = theme => ({
    container: {
        marginTop: theme.spacing(4)
    },
    cardContent: {
        padding: theme.spacing(2)
    }
});

class BaseEditor extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.api = new ApiService();
        this.state = { disciplineList: [] }
        this.loadDisciplines()

    }

    loadDisciplines() {
        this.api.call('get.disciplineList', {}, null).then((result) => {
            console.log(result)
            this.setState({ disciplineList: result })

        }).catch((err) => {
            console.log(err)
        });
    }

    componentWillMount() {
        if (!this.api.loggedIn())
            this.props.history.replace('/login');
    }

    directTo(discipline) {
        return () => this.props.history.push(`/editor/${discipline.DisciplineID}/${discipline.LanguageID}`, { name: discipline.Name })
    }

    render() {
        const classes = this.props.classes
        return (
            <React.Fragment>
                <TopBar {...this.props} title={'Редактор'} />
                <Container maxWidth="sm" className={classes.container}>
                {/* <Grid container spacing={1}> */}
                <Card style={{ backgroundColor: "rgb(235, 236, 240)" }}>
                        <div style={{ flexGrow: 1, height: "82px" }}>
                            <h2 style={{ flexGrow: 1, marginLeft: "20px" }}>
                                <span>{"Выберете дисциплину"}</span>
                            </h2>
                        </div>
                        <br />
                        <List>
                            {this.state.disciplineList.length === 0 ? <h1 style={{ marginLeft: "20px" }}>Загрузка.....</h1> :
                                this.state.disciplineList.map(discipline => {
                                    return (
                                        <Fragment>
                                            <Paper onClick={this.directTo(discipline)} style={{ marginLeft:"20px", marginRight:"20px" }}>
                                                <ListItem >
                                                    <ListItemText
                                                        primary={discipline.Name}
                                                    />
                                                </ListItem>
                                            </Paper>
                                            <br />
                                        </Fragment>
                                    )
                                })
                            }
                        </List>
                    </Card>
                    

                    {/* </Grid> */}
                </Container>
            </React.Fragment>
        );
    }


}

export default withStyles(styles)(withAuth(BaseEditor));